import { createContext, useContext, useLayoutEffect } from 'react';

/**
 * Lets MainLayout know whether the current screen already renders the
 * connection-state + notification cluster (PageHeaderMeta) in its own header.
 * When nothing has registered, the layout draws a fallback cluster top-right so
 * every screen carries it exactly once.
 *
 * Outside MainLayout the default is a no-op, so PageHeaderMeta keeps working
 * on standalone screens.
 */
export const PageHeaderMetaRegistry = createContext<() => () => void>(() => () => {});

/** Registers the calling PageHeaderMeta for as long as it is mounted. */
export function useRegisterPageHeaderMeta(enabled = true) {
  const register = useContext(PageHeaderMetaRegistry);
  // Layout effect: the registration lands before paint, so a page that has its
  // own cluster never flashes the fallback.
  useLayoutEffect(() => (enabled ? register() : undefined), [register, enabled]);
}
